import { Component, Input, OnInit, } from '@angular/core';
import { ThemeConstantService } from '../../../shared/services/theme-constant.service';
import { FanContactsService } from 'src/app/services/fan-contacts.service';

@Component({
    selector: 'privacy-policy',
    templateUrl: 'privacy-policy.component.html'
})

export class PrivacyPolicyComponent {

}